import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import getFileExtension from 'utils/getFileExtension';
import uuidv4 from 'uuid/v4';
import Axios from 'axios';
import { FIRESTOP_LABEL_TYPE } from '../constants/firestopLabelType';
import { getFirestopLabelUploadSignedUrl } from '../services/get-firestop-label-upload-signed-url.service';
import { postCreateFirestopLabels } from '../services/post-create-firestop-labels.service';

export const createFirestopLabels = createAsyncThunk(
  'firestopDocumentation/createFirestopLabels',
  async ({ firestopItemId, listId, files }, { getState, rejectWithValue }) => {
    const projectId = selectSelectedProjectId(getState());

    try {
      const firestopLabelsToCreate = [];

      for (const file of files) {
        if (!file) {
          continue;
        }

        const id = uuidv4();
        const fileExtension = getFileExtension(file.name);
        const s3FileName = `${id}.${fileExtension}`;

        const signedUrl = await getFirestopLabelUploadSignedUrl({
          projectId,
          labelId: id,
          fileName: s3FileName,
          contentType: file.type,
        });

        await Axios.put(signedUrl, file, {
          headers: { 'Content-Type': file.type },
        });

        firestopLabelsToCreate.push({
          id,
          type: FIRESTOP_LABEL_TYPE,
          ...(firestopItemId ? { firestopItemId } : {}),
          ...(listId ? { listId } : {}),
          projectId,
          name: file.name,
          s3FileName,
          contentType: file.type,
        });
      }

      const response = await postCreateFirestopLabels(
        projectId,
        firestopLabelsToCreate
      );

      return response;
    } catch (error) {
      return rejectWithValue(error?.message || 'Label creation failed');
    }
  }
);
